import type { BuildingId } from './Building.interface';
import type { DeliveryPointId } from './DeliveryPoint.interface';
import type { DeliveryPointMetric, TimeseriesIndicatorCode } from './Timeseries.interface';

export interface DeliveryPointCompletenessRequestParams {
    deliveryPointIds: DeliveryPointId[];
    startDate?: string;
    endDate?: string;
    years?: number[];
    metrics: DeliveryPointMetric;
    indicatorCodes: TimeseriesIndicatorCode;
}

// Using type literal here for data sources. Maybe there is a better solution ?
// tslint:disable:interface-over-type-literal
export type DeliveryPointCompletenessIndicator = {
    deliveryPointId: DeliveryPointId;
    date: string;
    metric: DeliveryPointMetric;
    dayCount: number;
    expectedDayCount: number;
};
// tslint:enable:interface-over-type-literal

// tslint:disable:interface-over-type-literal
export type DeliveryPointStatus = {
    date: string;
    activeBuildingsCount: number;
    activeDeliveryPointsCount: number;
    completeDeliveryPointsCount: number;
    withDataDeliveryPointsCount: number;
};
// tslint:enable:interface-over-type-literal

export interface DeliveryPointStatusRequestParams {
    buildingIds: BuildingId[];
    deliveryPointIds: DeliveryPointId[];
    indicatorCodes: TimeseriesIndicatorCode[];
    metrics: DeliveryPointMetric[];
    startDate: string;
    endDate: string;
    years?: number[];
}

export enum CompletenessMode {
    RELATIVE = 'RELATIVE',
    AVERAGE = 'AVERAGE'
}

export enum CompletenessTimeStep {
    MONTH = 'month',
    YEAR = 'year'
}
